import { League } from '../models';
import { LeagueRepository } from '../repositories';

export class GetLeagueByIdUseCase {
  constructor(private leagueRepository: LeagueRepository) {}

  async execute(leagueId: string): Promise<League | null> {
    return await this.leagueRepository.getById(leagueId);
  }
}
